import i18next from 'i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpApi from 'i18next-http-backend';
import constants from './shared/bk/modules/constants';
import bkLoadBackendData from 'Base/modules/bk/bk-load-backend-data';

let isInitialized = false;
i18next.on('initialized', () => (isInitialized = true));

const initI18next = async () => {
    if (isInitialized) {
        return;
    }

    const includeUuid = typeof i18nIncludeUuid !== 'undefined' ? i18nIncludeUuid : true;
    let accountUUID;

    if (includeUuid) {
        const accountData = await bkLoadBackendData.getAccount();
        accountUUID = accountData?.uuid;
    }

    return i18next.use(Backend).init({
        lng: language,
        fallbackLng: 'eng',
        debug: false,
        returnEmptyString: false,
        ns: ['account', 'bkms-system'],
        defaultNS: 'account',
        fallbackNS: 'bkms-system',
        backend: {
            backends: [
                LocalStorageBackend, // primary
                HttpApi, // fallback
            ],
            backendOptions: [
                {
                    prefix: 'i18next_res_',
                    expirationTime: 7 * 24 * 60 * 60 * 1000,
                    // Version applied to all languages, can be overwritten using the option `versions`
                    defaultVersion: 1,
                    // language versions
                    versions: {},
                    store: window.sessionStorage,
                },
                {
                    loadPath: `${constants.i18nBaseUrl}/i18n/{{lng}}/{{ns}}${accountUUID ? `-${accountUUID}` : ''}.json`,
                    //addPath: 'http://localhost:8012/i18n/add/{{lng}}/{{ns}}', // path to post missing resources
                },
            ],
        },
    });
};

export default initI18next;
